/** Small muted pill showing a post's admin-curated category, when present. Reused across Event/Offer/Help/Action cards. */
import type { PostCategory } from '@olimhub/shared'

export function CategoryChip({ category }: { category: PostCategory | null | undefined }) {
  if (!category) return null
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 'var(--radius-pill)',
        background: 'var(--surface-2)',
        border: '1px solid var(--border)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-xs)',
        color: 'var(--text-muted)',
        fontWeight: 500,
      }}
    >
      {category.name}
    </span>
  )
}
